(() => {
  const forms = document.querySelectorAll("form.bioluma-products__cart");
  const cartAddUrl = (window.routes?.cart_add_url || "/cart/add").replace(/\.js$/, "") + ".js";

  async function addAndOpenCart(form, submitBtn) {
    const cart = document.querySelector("cart-notification") || document.querySelector("cart-drawer");
    const formData = new FormData(form);

    if (!formData.get("quantity")) formData.append("quantity", "1");

    if (cart?.getSectionsToRender) {
      formData.append(
        "sections",
        cart.getSectionsToRender().map((section) => section.id).join(",")
      );
      formData.append("sections_url", window.location.pathname);
      cart.setActiveElement?.(submitBtn || document.activeElement);
    }

    if (submitBtn) submitBtn.disabled = true;

    try {
      const response = await fetch(cartAddUrl, {
        method: "POST",
        headers: {
          Accept: "application/javascript",
          "X-Requested-With": "XMLHttpRequest",
        },
        body: formData,
      });

      const data = await response.json();

      if (!response.ok || data.status) {
        console.error(data.description || data.message || "Não foi possível adicionar");
        return;
      }

      if (typeof publish === "function" && typeof PUB_SUB_EVENTS !== "undefined") {
        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: "bioluma-products",
          productVariantId: formData.get("id"),
          cartData: data,
        });
      }

      if (cart?.renderContents) {
        cart.classList?.remove("is-empty");
        cart.renderContents(data);
      } else if (typeof cart?.open === "function") {
        cart.open(submitBtn);
      } else {
        window.location = window.routes?.cart_url || "/cart";
      }
    } catch (error) {
      console.error(error);
    } finally {
      if (submitBtn) submitBtn.disabled = false;
    }
  }

  forms.forEach((form) => {
    form.addEventListener("submit", (event) => {
      event.preventDefault();
      const submitBtn = form.querySelector('[type="submit"]');
      if (submitBtn?.disabled) return;
      addAndOpenCart(form, submitBtn);
    });
  });
})();

if (!customElements.get("bioluma-products-carousel")) {
  customElements.define(
    "bioluma-products-carousel",
    class BiolumaProductsCarousel extends HTMLElement {
      connectedCallback() {
        if (this.bound) return;
        this.bound = true;

        this.track = this.querySelector("[data-carousel-track]");
        this.slides = Array.from(this.querySelectorAll("[data-carousel-slide]"));
        this.prevBtn = this.querySelector("[data-carousel-prev]");
        this.nextBtn = this.querySelector("[data-carousel-next]");
        this.page = 0;

        this.onPrev = (event) => {
          event.preventDefault();
          this.goTo(this.page - 1);
        };
        this.onNext = (event) => {
          event.preventDefault();
          this.goTo(this.page + 1);
        };
        this.onResize = () => {
          const pages = this.pageCount();
          if (this.page > pages - 1) this.page = Math.max(0, pages - 1);
          this.apply();
        };

        this.prevBtn?.addEventListener("click", this.onPrev);
        this.nextBtn?.addEventListener("click", this.onNext);
        window.addEventListener("resize", this.onResize);
        this.bindSwipe();
        this.apply();
      }

      disconnectedCallback() {
        this.prevBtn?.removeEventListener("click", this.onPrev);
        this.nextBtn?.removeEventListener("click", this.onNext);
        window.removeEventListener("resize", this.onResize);
        this.unbindSwipe();
        this.bound = false;
      }

      perPage() {
        const host = this.closest(".bioluma-products") || this;
        const raw = getComputedStyle(host).getPropertyValue("--bp-carousel-visible").trim();
        const value = Number(raw);
        return Number.isFinite(value) && value > 0 ? value : 1;
      }

      pageCount() {
        const step = Math.max(1, Math.floor(this.perPage()));
        return Math.max(1, Math.ceil(this.slides.length / step));
      }

      goTo(next) {
        const pages = this.pageCount();
        this.page = Math.max(0, Math.min(next, pages - 1));
        this.apply();
      }

      updateNav() {
        const pages = this.pageCount();
        const atStart = this.page <= 0;
        const atEnd = this.page >= pages - 1;

        if (this.prevBtn) {
          this.prevBtn.disabled = atStart;
          this.prevBtn.setAttribute("aria-disabled", atStart ? "true" : "false");
        }
        if (this.nextBtn) {
          this.nextBtn.disabled = atEnd;
          this.nextBtn.setAttribute("aria-disabled", atEnd ? "true" : "false");
        }
      }

      apply() {
        if (!this.track || !this.slides.length) return;
        const gap = parseFloat(getComputedStyle(this.track).gap) || 0;
        const slideWidth = this.slides[0].getBoundingClientRect().width;
        const step = Math.max(1, Math.floor(this.perPage()));
        const offset = this.page * step * (slideWidth + gap);
        this.track.style.transform = `translate3d(-${offset}px, 0, 0)`;
        this.updateNav();
      }

      bindSwipe() {
        let startX = 0;
        let deltaX = 0;
        let active = false;

        this.onPointerDown = (event) => {
          if (event.target.closest("a, button, form")) return;
          active = true;
          startX = event.clientX ?? event.touches?.[0]?.clientX ?? 0;
          deltaX = 0;
        };
        this.onPointerMove = (event) => {
          if (!active) return;
          const x = event.clientX ?? event.touches?.[0]?.clientX ?? startX;
          deltaX = x - startX;
        };
        this.onPointerUp = () => {
          if (!active) return;
          active = false;
          if (Math.abs(deltaX) < 40) return;
          if (deltaX < 0) this.goTo(this.page + 1);
          else this.goTo(this.page - 1);
        };

        this.addEventListener("pointerdown", this.onPointerDown);
        this.addEventListener("pointermove", this.onPointerMove);
        this.addEventListener("pointerup", this.onPointerUp);
        this.addEventListener("pointercancel", this.onPointerUp);
      }

      unbindSwipe() {
        this.removeEventListener("pointerdown", this.onPointerDown);
        this.removeEventListener("pointermove", this.onPointerMove);
        this.removeEventListener("pointerup", this.onPointerUp);
        this.removeEventListener("pointercancel", this.onPointerUp);
      }
    }
  );
}